import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2026-04-15 00:27:44 +0200 (Wed, 15 Apr 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 162195 $
//  Purpose   : admin components
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { Sel, Actions } from 'uix/registries';
import { XMenu } from 'uix/components';
import log from 'uix/logging';
import { useApi, useRouter } from 'uix/hooks';
// ---Globals
export const NodeSwitchItem = ({ node, onNodeChange, onlineOnly = false })=>{
    let { request, go } = useRouter();
    let { data } = useApi('node/list');
    let nodes = data?.nodes || [];
    if (onlineOnly) {
        nodes = nodes.filter(({ proc, state })=>proc?.online || state == 'online');
    }
    nodes = [
        {
            name: 'host'
        },
        ...nodes
    ];
    return /*#__PURE__*/ _jsx(XMenu.Dropdown, {
        options: nodes.map(({ name })=>({
                value: name,
                key: name,
                text: name
            })),
        value: node || request.query?.node || request.node || 'host',
        onValueChange: (v)=>onNodeChange ? onNodeChange(v) : go({
                updateQuery: {
                    node: v == 'host' ? null : v
                }
            }),
        search: true,
        title: "Switch node"
    });
};
